<template>
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">
            <a to="/" class="navbar-brand">Cloud Vending</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <!-- <li class="nav-item">
                        <router-link to="/" class="nav-link" active-class="active" aria-current="page">Home</router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link to="/expendedurias" class="nav-link" active-class="active" aria-current="page">Expendedurias</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/incidents" class="nav-link" active-class="active">Incidencias</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/envios" class="nav-link" active-class="active" aria-current="page">Envios</router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link to="/" class="nav-link" active-class="active" aria-current="page">Expendedurias</router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link to="/stock" class="nav-link" active-class="active" aria-current="page">Stock</router-link>
                    </li>
                    <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Herramientas
                      </a>
                      <ul class="dropdown-menu">
                        <li><router-link class="dropdown-item" to="/utilsexpendeduria">Utiles Expendeduria</router-link></li>
                        <li><a class="dropdown-item" href="#">No hace nada</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item" href="#">Esto tampoco hace nada</a></li>
                        <li><a class="dropdown-item" href="#">Esto peor</a></li>
                      </ul>
                    </li>
                    <li>
                        <div class="import-controls">
                          <button 
                            @click="handleImport"
                            :disabled="store.isLoading"
                            class="import-button"
                          >
                            <span v-if="!store.isLoading">🔄 Importar Datos</span>
                            <div v-else class="loading-container">
                              <div class="loading-spinner"></div>
                              <span>Importando...</span>
                            </div>
                          </button>
                          
                          <transition name="fade">
                            <div 
                            v-if="store.error || store.lastResult"
                            class="import-feedback"
                            :class="{ 'error': store.error, 'success': store.lastResult }"
                            >
                              <span v-if="store.error">❌ {{ store.error }}</span>
                              <span v-else-if="store.lastResult">
                                ✅ Importado: {{ store.lastResult.imported }} 
                                <!-- Actualizado: {{ store.lastResult.updated }}, 
                                Errores: {{ store.lastResult.errors }} -->
                              </span>
                            </div>
                          </transition>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
import { useImportStore } from '@/stores/useImportStore';

const store = useImportStore();

const handleImport = async () => {
  await store.startImport();
};

</script>

<style scoped>
.navbar {
  padding: 10px;
}

/* .btn {
  font-size: 0.9rem;
} */

.import-controls {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.import-button {
  padding: 0.5rem 1rem;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.import-button:disabled {
  background: #81C784;
  cursor: not-allowed;
}

.loading-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.loading-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.import-feedback {
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

.import-feedback.error {
  background: #ffebee;
  color: #d32f2f;
}

.import-feedback.success {
  background: #e8f5e9;
  color: #2e7d32;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
